
































import D3LineGraph from './evaluation_graph/d3_line_graph'
import D3AreaGraph from './evaluation_graph/d3_area_graph'
import D3VerticalLine from './evaluation_graph/d3_vertical_line'
import HoverIndicator from './evaluation_graph/hover_indicator'
import { getNormalizedScores } from '../analysis/graph_points'

export default {
  data() {
    return {
      shouldShowPositionIndicator: false,
      positionIndicatorIndex: this.positionIndex,
      width: 460,
      height: 120,
      lineColor: 'rgba(58,137,201,0.6)',
    }
  },

  methods: {
    positionIndexFromOffsetX(offsetX) {
      return ~~(this.positions.length * offsetX / this.width)
    },
    setPositionIndicatorIndex(e) {
      this.positionIndicatorIndex = this.positionIndexFromOffsetX(e.offsetX)
    },
    handleClick(e) {
      const positionIndex = this.positionIndexFromOffsetX(e.offsetX)
      this.$store.dispatch(`setPositionIndex`, positionIndex)
    },
  },

  computed: {
    positionIndex() {
      return this.$store.state.positionIndex
    },
    positions() {
      return this.$store.state.positions
    },
    graphPoints() {
      this.$store.state.currentAnalysis
      return getNormalizedScores(this.positions)
    },
    positionIndicatorX() {
      return this.positionIndicatorIndex / (this.positions.length - 1) * this.width
    }
  },

  components: {
    D3LineGraph,
    D3AreaGraph,
    D3VerticalLine,
    HoverIndicator,
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/evaluation_graph.vue